import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';

import { IncludeContent } from 'bricks';
import { isScreenBelow800 } from 'store/common/settings/breakpoint/selectors';
import {
  INSTALLMENT_SLUG,
  InstallmentCustomTab,
} from 'pages/ProductDetails/tabs/CustomContentTab/components/InstallmentCustomTab';

import TabRouterLayout from '../_TabLayout/index';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const CustomContentTab = ({ content, className, isMobile, activeSlug }) => (
  <TabRouterLayout className={cx(className)}>
    <div className={cx('component', isMobile && 'mobile')}>
      {activeSlug === INSTALLMENT_SLUG && <InstallmentCustomTab />}
      <IncludeContent htmlContent={content} className={cx('content')} />
    </div>
  </TabRouterLayout>
);

CustomContentTab.propTypes = {
  content: PropTypes.string,
  className: PropTypes.string,
  isMobile: PropTypes.bool,
  activeSlug: PropTypes.string,
};

const mapStateToProps = (state) => ({
  isMobile: isScreenBelow800(state),
  // isCreditAvailable: getCreditAvailability(state),
});

export default connect(mapStateToProps)(CustomContentTab);
